<div class="card">
    <div class="card-body">
        <div class="row" (click)="toggleCollapsed()">
            <div
                class="col notification-detail-longtext-content"
                [class.collapsed]="isCollapsed()"
                [class.expanded]="!isCollapsed()"
                tabindex="0"
            >
                <div class="row mb-2">
                    <div class="col d-flex align-items-center">
                        <fa-icon
                            [icon]="isCollapsed() ? faChevronRight : faChevronDown"
                            aria-hidden="true"
                            class="d-block d-lg-none me-3"
                        ></fa-icon>
                        <h3 class="user-select-auto m-0">{{ longtext().title }}</h3>
                    </div>
                </div>
                @for (line of longtext().linesHtml; track $index) {
                    <div class="user-select-auto mx-4 mx-lg-0" [innerHTML]="line"></div>
                }
            </div>
            <div
                class="col notification-detail-longtext-content d-none d-lg-block"
                [class.collapsed]="isCollapsed()"
                [class.expanded]="!isCollapsed()"
                tabindex="0"
            >
                <ng-container *ngTemplateOutlet="preclarification"></ng-container>
            </div>
        </div>
        <div class="row d-none d-lg-block">
            <div class="col bg-white text-center" (click)="toggleCollapsed()">
                <fa-icon [icon]="isCollapsed() ? faChevronDown : faChevronUp"></fa-icon>
                {{ isCollapsed() ? longtext().showMoreLabel : longtext().showLessLabel }}
            </div>
        </div>
    </div>
</div>
@if (longtext().preclarificationLinesHtml.length > 0) {
    <div class="card d-block d-lg-none mt-2">
        <div class="card-body">
            <ng-container *ngTemplateOutlet="preclarification"></ng-container>
        </div>
    </div>
}

<ng-template #preclarification>
    <div
        class="d-flex preclarification-content align-items-center"
        (click)="togglePreclarification()"
        [class.collapsed]="isPreclarificationHidden()"
        [class.expanded]="!isPreclarificationHidden()"
    >
        <fa-icon
            [icon]="isPreclarificationHidden() ? faChevronRight : faChevronDown"
            aria-hidden="true"
            class="d-block d-lg-none me-3"
        ></fa-icon>
        <h3 class="m-0">{{ longtext().preclarificationTitle }}</h3>
    </div>
    @if (!isPreclarificationHidden()) {
        <div>
            @for (line of longtext().preclarificationLinesHtml; track $index) {
                <div class="user-select-auto mt-2" [innerHTML]="line"></div>
            }
        </div>
    }
</ng-template>
